import './LineItemsStep.scss';

import { bem } from 'mission-control-common-components';
import React, { useMemo, useRef } from 'react';

import UploadTagSheetContentWrapper from '../components/UploadTagSheetContentWrapper';
import UploadTagSheetHeader from '../components/UploadTagSheetHeader/UploadTagSheetHeader';
import UploadTagSheetHeaderTitle from '../components/UploadTagSheetHeaderTitle/UploadTagSheetHeaderTitle';
import { useUploadTagSheetContext } from '../UploadTagSheetStepperProvider/UploadTagSheetStepperProvider';
import { SAVE_DISABLED_TOOLTIP } from '../validation/constants';
import { validateLineItems } from '../validation/validateLineItems';
import { TAG_SHEET_LINE_ITEM_STEP_TITLE, TAG_SHEET_NO_SELECTED_DATA_TITLE } from './constants';
import useAutoScrollOnDrag from './hooks/useAutoScrollOnDrag';
import LineItemsTable from './LineItemsTable/LineItemsTable';

const [, element] = bem('line-items-step');

const LineItemsStep = (): React.JSX.Element => {
  const { parseResult, setParseResult, goToNextStep } = useUploadTagSheetContext();

  const tableContainerRef = useRef<HTMLDivElement>(null);
  const autoScroll = useAutoScrollOnDrag(tableContainerRef);
  const canSave = useMemo(() => (parseResult ? validateLineItems(parseResult).canSave : false), [parseResult]);
  const tooltipText = !canSave && parseResult ? SAVE_DISABLED_TOOLTIP : undefined;

  return (
    <div>
      <UploadTagSheetHeader
        title={
          <UploadTagSheetHeaderTitle title={TAG_SHEET_LINE_ITEM_STEP_TITLE} vendorName={parseResult?.vendor.name} />
        }
        confirmButtonDisabled={!canSave}
        confirmText="Review"
        onNext={goToNextStep}
        tooltipText={tooltipText}
      />
      {parseResult ? (
        <div
          ref={tableContainerRef}
          className={element('table-container')}
          onDragOver={autoScroll.onDragOver}
          onDragLeave={autoScroll.onDragLeave}
          onDrop={autoScroll.onDrop}
          onDragEnd={autoScroll.onDragEnd}
        >
          <LineItemsTable parseResult={parseResult} setParseResult={setParseResult} />
        </div>
      ) : (
        <UploadTagSheetContentWrapper>
          <p>{TAG_SHEET_NO_SELECTED_DATA_TITLE}</p>
        </UploadTagSheetContentWrapper>
      )}
    </div>
  );
};

export default LineItemsStep;
